import * as React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from 'helpers/theme';
import classNames from 'classnames';
import QuickInfo from '../QuickInfo';
import Courses from 'components/Menu/SideMenu/Icons/Courses';
import Delegates from 'components/Menu/SideMenu/Icons/Delegates';
import Certificates from 'components/Menu/SideMenu/Icons/Certificates';
import Expires from 'components/Menu/SideMenu/Icons/Expires';

const useStyles = createUseStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '45px'
  },
  spacer: {
    width: theme.spacing(3)
  },
  quickOverviewRoot: {
    display: 'flex',
    alignItems: 'center'
  }
}));

type Props = {
  purchasedCourses: number;
  numDelegates: number;
  numValidCertificates: number;
  numCertificatesExpiringSoon: number;
};

function QuickOverview({
  purchasedCourses,
  numDelegates,
  numValidCertificates,
  numCertificatesExpiringSoon
}: Props) {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classes.quickOverviewRoot}>
      <div className={classes.root}>
        <QuickInfo
          icon={<Courses width={35} color="#6A728F" />}
          text="Courses"
          value={purchasedCourses}
        />
        <QuickInfo
          icon={<Delegates width={40} color="#6A728F" />}
          text="Delegates"
          value={numDelegates}
        />
        <QuickInfo
          icon={<Certificates width={22} color="#17BF2D" />}
          text="Certificates"
          value={numValidCertificates}
        />
        <QuickInfo
          icon={<Expires color="#FB3226" />}
          text="Expire Soon"
          value={numCertificatesExpiringSoon}
        />
      </div>
    </div>
  );
}

export default QuickOverview;
